import React, { useState } from "react";
import "./FAQSection.css";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "What is the minimum amount for credit card swiping?",
    a: "There is no minimum amount. You can swipe any amount from your credit card and get instant cash."
  },
  {
    q: "How long does the cash transfer take?",
    a: "Cash is transferred to your bank account within 5 minutes of swiping. It's instant and hassle-free."
  },
  {
    q: "Which credit cards do you accept?",
    a: "We accept all major credit cards including Visa, MasterCard, RuPay, American Express, and Diners Club from all banks."
  },
  {
    q: "Is this service safe and legal?",
    a: "Yes, we are a registered business. All transactions are secure, encrypted, and we provide proper receipts for every transaction."
  },
  {
    q: "What are your service charges?",
    a: "Our rates start from just 1.79% for Visa cards and 1.98% for RuPay and MasterCard. These are the lowest rates in Chennai."
  },
  {
    q: "Do you pay credit card bills?",
    a: "Yes! We offer credit card bill payment services. We ensure your bills are paid on time so you never miss a due date."
  },
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        
        <div className="faq-header fade-in-up">
          <h2 className="faq-title orange-gradient-text">
            Frequently Asked Questions
          </h2>
          <p className="faq-subtitle">
            Got questions? We've got answers.
          </p>
        </div>

        <div className="faq-list fade-in-up">
          {faqs.map((faq, i) => (
            <div 
              key={i} 
              className={`faq-item ${activeIndex === i ? "active" : ""}`}
            >
              <button 
                className="faq-question" 
                onClick={() => toggleAccordion(i)}
                aria-expanded={activeIndex === i}
              >
                <span>{faq.q}</span>
                <ChevronDown className="faq-icon" size={20} />
              </button>
              
              <div className="faq-answer">
                <div className="faq-answer-content">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FAQSection;